// removed by extract-text-webpack-plugin
module.exports = {"callAreaBackground":"callAreaBackground__hyvUt","callArea":"callArea__RQGPc","closeBtn":"closeBtn__2zG_9"};


//////////////////
// WEBPACK FOOTER
// ./components/communication/communication-component/style.scss
// module id = 3dqK
// module chunks = 27